module.exports = [
    '$q',
    '$rootScope',
    'SavedSearchEndpoint',
    '_',
    'Notify',
    'PostFilters',
function (
    $q,
    $rootScope,
    SavedSearchEndpoint,
    _,
    Notify,
    PostFilters
) {
    return {
        restrict: 'E',
        template: require('./savedsearch-update.html'),
        link: function ($scope, $element, $attrs) {
            if (!$scope.savedSearch) {
                throw {
                    message: 'savedsearchEditor must be passed a saved-search parameter'
                };
            }

            // Compare current filters to saved filters
            $scope.filtersChanged = function () {
                return !angular.equals($scope.filters, $scope.savedSearch.filter);
            };

            $scope.saveSearch = function () {
                // Copy the current filters into our search..
                $scope.savedSearch.filter = PostFilters.getQueryParams($scope.filters);

                SavedSearchEndpoint.update($scope.savedSearch)
                .$promise
                .then(function (savedSearch) {
                    $rootScope.$broadcast('event:savedSearch:update');
                }, function (errorResponse) {
                    Notify.apiErrors(errorResponse);
                });
            };

            $scope.resetSearch = function () {
                PostFilters.setFilters($scope.savedSearch.filter);
                // Slight hack: to avoid incorrectly detecting a changed search
                // we push the real query we're using back into the saved search.
                // This will now include any default params we excluded before
                $scope.savedSearch.filter = angular.copy(PostFilters.getFilters());
            };
        }
    };
}];



// WEBPACK FOOTER //
// ./app/main/posts/savedsearches/update-directive.js